export interface ICalendarPersistence {
	currentMonth: Date;
	propertyId: string | number | undefined;
}

export const ActionTypes = {
	UPDATE_PERSISTENCE: 'CALENDAR_UPDATE_PERSISTENCE',
};

export const setCalendarPersistence = (persistence: ICalendarPersistence) => ({ type: ActionTypes.UPDATE_PERSISTENCE, payload: persistence });

export type Actions = ReturnType<typeof setCalendarPersistence>;
